//React
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Form } from 'react-bootstrap';
//API
import {
  DistributorApi,
  HospitalApi,
  TemplateApi,
  WoundApi,
} from '../../apis/index';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Switch from '@mui/material/Switch';
//Material-UI
import Grid from '@material-ui/core/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

//Components
import MyLoading from '../../components/Loading.js';
import BasicModal, { ModalComponent } from '../../components/Modal.js';
import ReactSecureStorage from 'react-secure-storage';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(17px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#3F598C',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
    transform: 'translateY(5%)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const CustomFormControl = styled(Form.Control)`
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const HospitalApprove = (props) => {
  const encryptId = props.match.params.id;
  const [requestForm, setRequestForm] = useState([]);

  const [hospital, setHospital] = useState({});
  const [woundType, setWoundType] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [defaultTemplates, setDefaultTemplates] = useState({});
  const settings = {
    togglenYn: false,
    hiddenYn: false,
    autoIssued: true,
    aiDrawYn: true,
    disableYn: false,
    woundName: null,
    kitMetaId: null,
    woundListId: null,
  };

  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalStatus2, setModalStatus2] = useState(false);
  const [CheckmodalContent, setCheckmodalContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRequestForm();
    getWoundTypeList();
    getTemplateList();
  }, []);

  const getRequestForm = async () => {
    try {
      const resRequestForm = await DistributorApi.getRequestForm(encryptId);
      if (resRequestForm.data.approved) {
        alert('이미 처리된 요청입니다.');
        const fetchHospitalInfo = async () => {
          try {
            // Fetch hospital info
            const hospitalRes = await HospitalApi.getHospitalID(
              resRequestForm.data.hospitalId,
            );
            setHospital(hospitalRes.data);

            // Fetch wound list
            const woundRes = await WoundApi.getWoundList();
            const wound = woundRes.data.map((woundList) => ({
              woundListId: woundList.id,
              woundName: woundList.woundName,
            }));
            const setting = wound.map((item) => ({
              [item.woundListId]: { ...settings, ...item },
            }));
            const updatedArr = setting.map((item) => {
              const key = Object.keys(item)[0];
              const foundItem = hospitalRes.data.woundFlagRegisterList.find(
                (item1) => item1.woundListId.toString() === key,
              );

              return foundItem
                ? {
                    [key]: {
                      ...item[key],
                      ...foundItem,
                      togglenYn: true,
                    },
                  }
                : item;
            });

            setWoundType(updatedArr);

            // Fetch template list
            const templateRes = await TemplateApi.getTemplate();
            setTemplateList(templateRes.data);
          } catch (error) {
            console.error('Failed to fetch hospital data:', error);
          }
        };

        fetchHospitalInfo();
      }
      setRequestForm(resRequestForm.data);
    } catch (error) {
      console.error('Failed to fetch getRequestForm data:', error);
    }
  };

  const getWoundTypeList = async () => {
    try {
      const woundRes = await WoundApi.getWoundList();
      const wound = woundRes.data.map((woundList) => ({
        woundListId: woundList.id,
        woundName: woundList.woundName,
      }));

      const result = wound.map((item) => ({
        [item.woundListId]: { ...settings, ...item },
      }));

      setWoundType(result);
    } catch (error) {
      console.error('Failed to fetch Wound data:', error);
    }
  };

  const getTemplateList = async () => {
    try {
      const templateRes = await TemplateApi.getTemplate();
      setTemplateList(templateRes.data);
    } catch (error) {
      console.error('Failed to fetch Template data:', error);
    }
  };

  const templateName = useMemo(() => {
    return templateList.map((template) => ({
      label: template.templateName,
      id: template.id,
    }));
  }, [templateList]);

  useEffect(() => {
    const newDefaultTemplates = {};
    woundType.forEach((woundList) => {
      const wound = woundList[Object.keys(woundList)[0]];
      const woundListId = Object.keys(woundList)[0];
      if (wound.kitMetaId == null) {
        newDefaultTemplates[woundListId] = null;
      } else {
        const matchedTemplate = templateName.find(
          (item) => item.id === wound.kitMetaId,
        );
        newDefaultTemplates[woundListId] = matchedTemplate || null;
      }
    });
    setDefaultTemplates(newDefaultTemplates);
  }, [templateName, woundType]);

  const handleChangeHospital = (e) => {
    setHospital({
      ...hospital,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCountryCode = (e, value) => {
    if (value) {
      setHospital({
        ...hospital,
        countryCode: value.label,
      });
    } else {
      setHospital({
        ...hospital,
        countryCode: '',
      });
    }
  };

  useEffect(() => {
    if (requestForm.countryCode === 'USA') {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: 'APLICOR 3D',
      }));
    } else if (requestForm.countryCode) {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: 'Dr. INVIVO',
      }));
    } else {
      setHospital((prevHospital) => ({
        ...prevHospital,
        productName: '',
      }));
    }
  }, [requestForm.countryCode]);

  const handleChangeWound = (e) => {
    const [woundListId, key] = e.target.name.split(',');
    setWoundType((prevWoundType) => {
      const newWoundType = [...prevWoundType];
      const index = newWoundType.findIndex((obj) =>
        obj.hasOwnProperty(woundListId),
      );
      if (index !== -1) {
        newWoundType[index] = {
          ...newWoundType[index],
          [woundListId]: {
            ...newWoundType[index][woundListId],
            [key]: e.target.checked,
          },
        };
      }
      return newWoundType;
    });
  };

  const templateLink = (data) => {
    const objectKey = woundType.find((obj) => obj.hasOwnProperty(data));
    const valueOfkitMetaId = objectKey ? objectKey[data].kitMetaId : null;

    if (valueOfkitMetaId) {
      window.open('/updateTemplate/' + valueOfkitMetaId);
    }
  };

  const handleChangeTemplate = (woundType) => (e, value) => {
    const [woundListId, key] = woundType.split(',');
    setWoundType((prevWoundType) => {
      const newWoundType = [...prevWoundType];
      const index = newWoundType.findIndex((obj) =>
        obj.hasOwnProperty(woundListId),
      );
      if (index !== -1) {
        newWoundType[index] = {
          ...newWoundType[index],
          [woundListId]: {
            ...newWoundType[index][woundListId],
            [key]: value ? value.id : null,
          },
        };
      }
      return newWoundType;
    });
  };

  const requestDistributor = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    // FormData에 병원 정보 추가
    formData.append('hospitalName', requestForm.hospitalName);
    formData.append('email', requestForm.email);
    formData.append('countryCode', requestForm.countryCode);
    formData.append('productName', hospital.productName);
    formData.append('approveEmail', ReactSecureStorage.getItem('email'));

    // woundType 필터링 및 검증
    const woundData = woundType.filter(
      (wt) => wt[Object.keys(wt)[0]].togglenYn,
    );

    if (woundData.length === 0) {
      showModalWithContent('wound를 최소 하나 이상 선택해주세요.');
      handleModalOpen();
      setLoading(false);
      return;
    }

    let flag = true;
    // woundData를 FormData에 추가
    woundData.forEach((wd, i) => {
      const key = Object.keys(wd)[0];

      if (!wd[key].kitMetaId) {
        showModalWithContent('설정된 Template이 없습니다.');
        handleModalOpen();
        setLoading(false);
        flag = false;
        return;
      }

      formData.append(`woundFlagRegisterList[${i}].aiDrawYn`, wd[key].aiDrawYn);
      formData.append(
        `woundFlagRegisterList[${i}].autoIssued`,
        wd[key].autoIssued,
      );
      formData.append(
        `woundFlagRegisterList[${i}].disableYn`,
        wd[key].disableYn,
      );
      formData.append(`woundFlagRegisterList[${i}].hiddenYn`, wd[key].hiddenYn);
      formData.append(
        `woundFlagRegisterList[${i}].kitMetaId`,
        wd[key].kitMetaId,
      );
      formData.append(
        `woundFlagRegisterList[${i}].woundListId`,
        wd[key].woundListId,
      );
    });

    if (flag) {
      try {
        const res = await DistributorApi.approveHospital(formData);
        if (res.statusCode === 200) {
          props.history.push('/hospitalRequestList');
        } else {
          setLoading(false);
          showModalWithContent(res.message);
          handleModalOpen();
          return;
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => {
    setModalStatus(false);
  };

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    return date.toISOString().replace('T', ' ').substring(0, 19);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);

  const [handleClose, setHandleClose] = useState(() => () => {});

  useEffect(() => {
    if (CheckmodalContent) {
      setModalStatus2(true);
    }
  }, [CheckmodalContent]);

  const emailStyle = {
    border: '1px solid #D9D9D9',
  };

  return (
    <div>
      <style>
        {`
            .form-control::placeholder {
              color: #B6BCC5;
            }
            `}
      </style>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <LocalHospitalIcon
          label="Hospital Request"
          style={{
            color: 'rgb(63, 89, 140)',
            opacity: '90%',
          }}
        />
        <h1 style={{ margin: 0 }}>Hospital Account Approval Page</h1>
      </div>

      <Form
        onSubmit={requestDistributor}
        onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
      >
        <Form.Group>
          <span>Email</span>
          <span style={{ color: 'red' }}> *</span>
          <div style={{ display: 'flex', position: 'relative' }}>
            <CustomFormControl
              style={{ margin: '0px' }}
              disabled={true}
              type="text"
              placeholder="Enter email address..."
              name="email"
              autoComplete="off"
              value={requestForm.email}
              maxLength={100}
            />
          </div>
        </Form.Group>
        <Form.Group>
          <span>Hospital name</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            disabled={true}
            type="text"
            placeholder="Enter name..."
            name="memberName"
            autoComplete="off"
            value={requestForm.hospitalName}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group>
          <span>Country Code</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            disabled={true}
            type="text"
            placeholder="Enter countryCode..."
            name="countryCode"
            autoComplete="off"
            value={requestForm.countryCode}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group>
          <span>Requested Distributor Company</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            disabled={true}
            type="text"
            placeholder="Enter distributorName..."
            name="distributorName"
            autoComplete="off"
            value={requestForm.distributorName}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group>
          <span>Rokit Healthcare Department</span>
          <span style={{ color: 'red' }}> *</span>
          <Form.Control
            style={{ margin: '0px' }}
            disabled={true}
            type="text"
            placeholder="Enter department..."
            name="memberName"
            autoComplete="off"
            value={requestForm.department}
            maxLength={30}
          />
        </Form.Group>
        <Form.Group>
          <span>Product Name</span>
          <Form.Control
            type="text"
            placeholder="Product Name"
            name="productName"
            autoComplete="off"
            required
            value={hospital.productName || ''}
            disabled
          />
        </Form.Group>

        <div style={{ display: 'flex', paddingTop: '10px' }}>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>ST-160-160</div>
              <div style={{ marginTop: '-15px' }}>___________</div>
              <div style={{ marginTop: '-5px' }}>①</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>KIT-02</div>
              <div style={{ marginTop: '-15px' }}>______</div>
              <div style={{ marginTop: '-5px' }}>②</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>EV</div>
              <div style={{ marginTop: '-15px' }}>__</div>
              <div style={{ marginTop: '-5px' }}>③</div>
            </div>
          </div>
          <div style={{ marginTop: '5px' }}> - </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057',
              }}
            >
              <div>D1-01</div>
              <div style={{ marginTop: '-15px' }}>_____</div>
              <div style={{ marginTop: '-5px' }}>④</div>
            </div>
          </div>
          <div style={{ paddingLeft: '30px', color: '#495057' }}>
            <div>
              ① 압출량(ST): 강도 조절 미 버전=160-160, 강도 조절 버전=110-110
            </div>
            <div>② KIT 종류(KIT): AI Regen KIT=01, 분리형 키트=02</div>
            <div>③ 필라멘트 종류: Evonic(EV), Glueone(GL)</div>
            <div>④ Dispenser1(D1) 종류: 구형=01, 신형=02</div>
          </div>
        </div>

        <span>Wound Type</span>
        <span style={{ color: 'red' }}> *</span>
        {woundType.map((woundList, index) => {
          const woundData = woundList[Object.keys(woundList)];
          const woundListId = Object.keys(woundList)[0];
          return (
            <div key={index}>
              <div
                style={{
                  transition: 'all 0.5s',
                  background: '#fff',
                  width: '100%',
                  padding: '20px 20px 10px 20px',
                  marginBottom: 30,
                  alignItems: 'center',
                  borderRadius: '10px',
                  flexDirection: 'row',
                  border: woundData.togglenYn
                    ? '1px solid #3F598C'
                    : '1px solid #D9D9D9',
                }}
              >
                <FormControlLabel
                  style={{ userSelect: 'none' }}
                  control={<IOSSwitch sx={{ m: 1 }} />}
                  label={
                    <div sx={{ fontSize: '24px', fontWeight: '500' }}>
                      {woundData.woundName}
                    </div>
                  }
                  labelPlacement="start"
                  name={`${woundData.woundListId},togglenYn`}
                  checked={woundData.togglenYn}
                  disabled={requestForm.approved ? true : false}
                  onChange={handleChangeWound}
                />
                <div
                  style={{
                    transition: 'all 0.5s',
                    boxSizing: 'border-box',
                    height: woundData.togglenYn ? '150px' : '0',
                    opacity: woundData.togglenYn ? '1' : '0',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-around',
                    }}
                  >
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.autoIssued}
                          disabled={requestForm.approved ? true : false}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},autoIssued`}
                        />
                      }
                      label="Auto Issue"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.aiDrawYn}
                          disabled={requestForm.approved ? true : false}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},aiDrawYn`}
                        />
                      }
                      label="Auto Draw"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.hiddenYn}
                          disabled={requestForm.approved ? true : false}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},hiddenYn`}
                        />
                      }
                      label="Hidden"
                    />
                    <FormControlLabel
                      style={{ userSelect: 'none' }}
                      control={
                        <Checkbox
                          sx={{
                            color: '#3F598C',
                            '&.Mui-checked': { color: '#3F598C' },
                          }}
                          checked={woundData.disableYn}
                          disabled={requestForm.approved ? true : false}
                          onChange={handleChangeWound}
                          name={`${woundData.woundListId},disableYn`}
                        />
                      }
                      label="Disable"
                    />
                  </div>
                  <Form.Group>
                    <AutoComplete
                      disablePortal
                      value={defaultTemplates[woundListId] || null}
                      options={templateName}
                      disabled={requestForm.approved ? true : false}
                      onChange={handleChangeTemplate(
                        `${woundData.woundListId},kitMetaId`,
                      )}
                      sx={{ width: '100%' }}
                      renderInput={(params) => (
                        <TextField {...params} label="Set Template" />
                      )}
                    />
                  </Form.Group>
                  <button
                    type="button"
                    style={{ marginTop: '-10px' }}
                    hidden={true}
                    onClick={() => templateLink(woundData.woundListId)}
                  >
                    Template 이동
                  </button>
                </div>
              </div>
            </div>
          );
        })}
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Request Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {requestForm.insertDate && (
                <div>{setDate(requestForm.insertDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>
              Distributor's Email for Request
            </Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {requestForm.distributorEmail}
            </div>
          </Form.Group>
        </div>
        <div style={{ display: requestForm.approved ? 'flex' : 'none' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>
              Approval Date
            </Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {requestForm.modifyDate && (
                <div>{setDate(requestForm.modifyDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>
              Approver's Email
            </Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {requestForm.approvedEmail}
            </div>
          </Form.Group>
        </div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <button
            type="button"
            onClick={() => props.history.push('/hospitalRequestList')}
            style={{ marginRight: '25px', fontSize: '18px', fontWeight: '500' }}
          >
            BACK
          </button>
          <button
            className="blue"
            type="submit"
            style={{ maringLeft: '25px', fontSize: '18px', fontWeight: '500' }}
            disabled={requestForm.approved ? true : false}
          >
            APPROVE
          </button>
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
        <ModalComponent
          open={modalStatus2}
          handleModalClose={(userChoice) => handleClose(userChoice)}
          content={CheckmodalContent}
        />
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </div>
  );
};

export default HospitalApprove;
